module.exports = __webpack_public_path__ + "img/icon5.f1ea70b1.png";